import { render, staticRenderFns } from "./ChangeDept.vue?vue&type=template&id=661f0a6f&"
import script from "./ChangeDept.vue?vue&type=script&lang=js&"
export * from "./ChangeDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports